
<div class="progress-bar-conatiner" :type="type" :size="size" :mode="mode">
	<div v-if="label" class="progress-bar-label">
		{{ label }}
	</div>
	<div class="progress-bar-wrapper" :shape="shape">
		<div class="progress-bar" :style="{ transform: 'scaleX(' + scaleX + ')' }" />
		<div class="progress-bar-status">
			<slot v-if="size !== 'small'" />
		</div>
		<div
			v-for="line in lines"
			:key="line.value"
			:type="line.type"
			:style="{ left: line.value + '%' }"
			class="progress-bar-vert-line"
		/>
	</div>
</div>
